import { objectMap } from '@shared/util/object';
import { lazy } from 'react';
import { FormattedMessage as IntlFormattedMessage } from '../../../../node_modules/react-intl';
import { isInContextEditorEnabled } from './helpers';

export * from '../../../../node_modules/react-intl';

const TolgeeT = isInContextEditorEnabled()
  ? lazy(async () => ({ default: (await import('@tolgee/react')).T }))
  : null;

/* istanbul ignore next */
export const FormattedMessage: typeof IntlFormattedMessage = ({ id, values, ...rest }) => {
  if (TolgeeT) {
    const params = values
      ? objectMap(values, ([k, v]) => [k, typeof v === 'object' ? '✳️' : v])
      : {};
    return (
      <span>
        <TolgeeT keyName={id!} params={params as any} />
      </span>
    );
  }
  return <IntlFormattedMessage id={id} values={values} {...rest} />;
};
